import { Navigate, Outlet } from 'react-router';

import { useAuth } from '../context/AuthProvider';

interface Props {
  loggedInPath: string;
}

export const UnauthenticatedGuard = ({ loggedInPath }: Props) => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) return <Navigate to={{ pathname: loggedInPath }} />;

  return <Outlet />;
};
